import React from 'react';
import ReportCenter from './ReportCenter';

function StaffTransactionSummaryPage() {
  return (
    <ReportCenter
      standaloneConfig={{
        businessReport: 'staff-transaction-summary',
        eyebrow: 'Staff Transaction Summary',
        title: 'Staff Transaction Summary',
        breadcrumbLabel: 'Staff Transaction Summary',
        description: 'Ringkasan transaksi staf aktif untuk memantau penjualan membership dan POS closing shift per periode.',
      }}
    />
  );
}

export default StaffTransactionSummaryPage;
